import styled from "styled-components";
import { ReactNode } from "react";

type Props = {
  $visible: boolean;
  onClick: () => void;
  children?: ReactNode;
};

export const IconWrapper = styled.div<Props>`
  font-size: 13px;
  height: 25px;
  width: 25px;
  z-index: 2;
  border-radius: 50%;
  background-color: white;
  box-shadow: 0 1px 3px rgb(0 0 0 / 12%), 0 1px 2px rgb(0 0 0 / 24%);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  ${(props) => (props.$visible ? "position: absolute;top: 5px;right: 10px;" : "")}
`;
